import { render, staticRenderFns } from "./listAlertItem.vue?vue&type=template&id=4a45f4f4&"
import script from "./listAlertItem.vue?vue&type=script&lang=js&"
export * from "./listAlertItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports